//Home.jsx

import React from "react";

import UserNav from "./UserNav";
import Event from "./Event.jsx";
import Footer from "./Footer.jsx";
import About from "./About.jsx";
import Sponsors from "./sponsors.jsx";
export default function Home() {
  return (
    <>
      <UserNav />

      <Event />

      <br />
      <br />
      <div id="about"></div>

      <About />
      <Sponsors />
      <br />
      <br />
      <div id="contact"></div>
      <Footer />
    </>
  );
}
